import { Component, OnInit, SecurityContext } from '@angular/core';
import { NetfirmLoginConstants } from './models/netfirm-login-constants.model';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
import { DropdownItem } from './models/dropdown-item.model';
import { NavigationEnd, Router } from '@angular/router';
import { DomSanitizer } from '@angular/platform-browser';
@Component({
	selector: 'netfirm-login-root',
	templateUrl: './app.component.html',
	styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
	public title = 'NetfirmLogin';
	public year = new Date().getFullYear();
	public region!: string;
	public showFooter = true;
	public isMigrated!: boolean;
	public currentLanguage!: DropdownItem;
	public supportedLanguages: DropdownItem[] = [
		{
			label: 'English (Canada)',
			value: 'en-CA',
		},
		{
			label: 'Français (Canada)',
			value: 'fr-CA',
		},
	];

	public constructor(
		private readonly translate: TranslateService,
		private readonly cookieService: CookieService,
		private readonly router: Router,
		private readonly sanitizer: DomSanitizer,
	) {}

	public ngOnInit(): void {
		const url = window.location.href;
		const hash = window.location.hash;
		this.router.events.subscribe(event => {
			const navigationHash = this.sanitizer.sanitize(SecurityContext.URL, window.location.hash) ?? '';
			if (event instanceof NavigationEnd) {
				if (navigationHash === '#/' || navigationHash === '#/login') {
					this.showFooter = true;
				} else {
					this.showFooter = false;
				}
			}
		});

		const isInternal = NetfirmLoginConstants.internalRoutes
			.map(routeURL => hash.includes(routeURL))
			.reduce((prev, next) => prev || next);
		if (hash.length > 2 && !isInternal) {
			document.cookie = `dashboardDeepLink=${url};expires=Session;path=/`;
		}

		const origin = window.location.origin.split('.');
		this.region = origin[origin.length - 1];

		const languageCode = this.cookieService.get('NFLanguageCode');
		const cookieLocale = this.cookieService.get('locale');
		this.isMigrated = Boolean(this.cookieService.get('isMigrated'));
		const browserLang = this.translate.getBrowserLang();
		let locale: string;
		if (languageCode) {
			locale = languageCode;
		} else if (cookieLocale) {
			locale = cookieLocale;
		} else {
			switch (browserLang) {
				case 'en': {
					locale = this.region === 'ca' ? 'en-CA' : 'en-US';
					break;
				}

				case 'fr':
					locale = 'fr-CA';
					break;
				default:
					locale = 'en-US';
			}
		}

		this.currentLanguage = this.supportedLanguages.find(l => l.value === locale) ?? this.supportedLanguages[0];
		this.translate.setDefaultLang('en-US');
		this.translate.use(locale);
	}

	public switchLanguage(selectedLanguage: string): void {
		this.translate.use(selectedLanguage);
		this.cookieService.set('NFLanguageCode', selectedLanguage, undefined, '/nextgen', undefined, undefined, 'Lax');
		this.cookieService.set('locale', selectedLanguage, undefined, '/nextgen', undefined, undefined, 'Lax');
	}
}
